import { HttpErrorResponse } from '@angular/common/http';

export class UnsupportedMediaTypeError extends Error {
    httpStatus = 415;

    constructor(res: HttpErrorResponse, message?: string) {
        super(message ? message : res.statusText);
        Object.setPrototypeOf(this, UnsupportedMediaTypeError.prototype);
    }
}
